<template>
  <div :class="css ? css: 'autocomplete'">
    <input
      :placeholder="placeholder"
      :type="type"
      class="form-control"
      :style="largura"
      v-model="search"
      @input="debouncedGetData"
      @keydown.down="onSetaParaBaixo"
      @keydown.up="onSetaParaCima"
      @keydown.enter="onEnter"
      v-bind:disabled="disabled"
    />

    <ul v-show="isOpen" class="autocomplete-results" :style="stylesItems">
      <li class="loading" v-if="isLoading"> Buscando...</li>

      <li v-else v-for="(result, indice) in results" :key="indice" @click="setResult(result)"
          class="autocomplete-result"
          :class="{ 'is-active': indice === arrowCounter }">
        {{ result.value }}
      </li>
    </ul>
  </div>
</template>

<script>
import AutoCompleteService from '@/services/AutoCompleteService'
import eventBus from '@/uteis/eventBus'
import lodash from 'lodash'

export default {

  data () {
    return {
      isLoading: false,
      search: '',
      results: [],
      isOpen: false,
      arrowCounter: -1,
      resultadoDaBusca: []
    }
  },

  props: {
    valor: { type: Object, required: false },
    minLength: { type: Number, required: false, default: 3 },
    placeholder: { type: String, required: false, default: '' },
    default: { type: String, required: false },
    items: { type: Array, required: false, default: () => [] },
    isAsync: { type: Boolean, required: false, default: false },
    url: { type: String, required: true },
    width: { type: Number, required: false, default: 100 },
    marginTop: { type: Number, required: false, default: 0 },
    mutation: { type: String, required: true },
    keyAttrName: { type: String, required: true },
    keyAttrFilter: { type: String, required: false, default: 'filtro' },
    valueAttrName: { type: String, required: true },
    disabled: { type: Boolean, required: false },
    eventBusAutoComplete: { type: String, required: false },
    delay: { type: Number, required: false, default: 500 },
    args: { type: Object, required: false, default: () => Object.assign({}) },
    css: { type: String, required: false },
    params: { type: Object, required: false, default: () => Object.assign({}) },
    type: { type: String, required: false, default: 'text' }
  },

  methods: {
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },

    getData () {
      this.$store.commit(this.mutation, {})

      if (this.search.length >= this.minLength && this.valor !== null) {
        if (this.isAsync) {
          this.isLoading = true
          this.buscarDados()
        } else {
          this.isOpen = true
          this.filtrarItems()
        }
      } else {
        this.isOpen = false
      }
    },

    async buscarDados () {
      this.isOpen = true

      Object.assign(this.params, {
        ...this.params
      })

      this.params[this.keyAttrFilter] = this.search

      const { data } = await this.service.pesquisar(this.params)
      this.results = []

      if (data.length > 0) {
        this.resultadoDaBusca = data
        const result = this.objectToSelectItems(data)
        this.results.push(...result)

        if (result.length === 1 && result[0].value === this.search) {
          this.setResult(result[0])
        }
      } else {
        this.results.push(this.$store.getters.getValorDefaultAutoComplete)
      }
      this.isLoading = !this.results
    },

    objectToSelectItems (data) {
      const result = []
      const indices = this.valueAttrName.split(' ')

      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        const selectData = {
          key: item[this.keyAttrName] || '',
          value: ''
        }

        for (const index of indices) {
          if (selectData.value !== '') {
            selectData.value += ' - '
          }
          selectData.value += item[index] || ''
        }

        result.push(selectData)
      }

      return result
    },

    selectItemsToObject (item) {
      const listaResult = this.resultadoDaBusca

      for (let i = 0; i < listaResult.length; i++) {
        for (const key in listaResult[i]) {
          if (key === this.keyAttrName) {
            if (item.key === listaResult[i][key]) {
              return listaResult[i]
            }
            break
          }
        }
      }
    },

    filtrarItems () {
      this.results = this.items.filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
    },

    setResult (result) {
      if (result.key !== null && result.key !== '') {
        const dadosDoResultado = this.selectItemsToObject(result)

        this.$store.commit(this.mutation, dadosDoResultado)

        this.sendResponse(dadosDoResultado)

        this.search = result.value
        this.isOpen = false
      }
    },

    onSetaParaBaixo () {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },

    onSetaParaCima () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },

    onEnter () {
      const valorSelecionado = this.selectItemsToObject(this.results[this.arrowCounter])

      this.$store.commit(this.mutation, valorSelecionado)
      this.sendResponse(valorSelecionado)
      this.search = this.results[this.arrowCounter].value
      this.isOpen = false
      this.arrowCounter = -1
    },

    sendResponse (data) {
      if (this.eventBusAutoComplete) {
        var response = { ...this.args, data: data }
        eventBus.$emit(this.eventBusAutoComplete, response)
      }
    }
  },

  watch: {
    items: (newValue, oldValue) => {
      if (this.isAsync) {
        this.results = newValue
        this.isOpen = true
        this.isLoading = false
      }
    },

    valor (newValue, oldValue) {
      if (!lodash.isEmpty(newValue)) {
        this.resultadoDaBusca.push(newValue)

        var selectItems = this.objectToSelectItems([newValue])
        this.results.push(...selectItems)
        this.setResult(selectItems[0])
      }
    }
  },

  computed: {
    largura () {
      return {
        width: `${this.width}%`
      }
    },
    stylesItems () {
      return this.results.length > 0 ? { height: '75px', background: 'white' } : { height: '25px' }
    },
    marginTopo () {
      return { marginTop: `${this.marginTop}px` }
    }
  },

  created () {
    this.service = new AutoCompleteService(this.url)
    this.debouncedGetData = lodash.debounce(this.getData, this.delay)
    this.search = this.default || ''

    if (this.valor) {
      this.resultadoDaBusca.push(this.valor)

      const selectItems = this.objectToSelectItems([this.valor])
      this.results.push(...selectItems)
      this.setResult(selectItems[0])
    }
  },

  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },

  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style lang="scss" scoped>

.autocomplete {
  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;

    .autocomplete-result {
      list-style: none;
      text-align: left;
      padding: 4px 2px;
      cursor: pointer;
    }
  }
}
</style>
